/**
 * BaseApiAdapter - Base class for all external API adapters
 * 
 * CHANGE HISTORY:
 * - 251030_0125 [pending] danielbeer: Created base adapter for Interactr API adapters
 * 
 * This is the foundation for all external API integrations (Google, iCloud, Exchange, etc.)
 */

export interface ApiAdapterCapabilities {
  read: boolean;
  write: boolean;
  delete: boolean;
  list: boolean;
  search: boolean;
}

export abstract class BaseApiAdapter {
  protected name: string;

  constructor(name: string = 'unknown') {
    this.name = name;
  }

  /**
   * Initialize the adapter
   */
  abstract initialize(): Promise<void>;

  /**
   * Get adapter name
   */
  getName(): string {
    return this.name;
  }

  /**
   * Check if adapter is available
   */
  abstract isAvailable(): Promise<boolean>;

  /**
   * Get adapter capabilities
   */
  getCapabilities(): ApiAdapterCapabilities {
    return {
      read: true,
      write: true,
      delete: true,
      list: true,
      search: false,
    };
  }
}

export default BaseApiAdapter;
